import { useEffect, useState } from "react";

const Loader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    isLoading && `Loading`
    // <div className="page-loader">
    //   <img src="/images/logo.png" alt="" />
    //   <div className="loader"></div>
    //   <div className="shadow"></div>
    // </div>
  );
};

export default Loader;
